/**
 * @generated SignedSource<<ba7564388ecfef463b6610ec5749ee79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AgendaMemberNoteStatus = "HIGH" | "MEDIUM" | "STANDARD";
import { FragmentRefs } from "relay-runtime";
export type MemberNote_Booking$data = {
  readonly startSlot: {
    readonly agenda: {
      readonly memberNote: {
        readonly body: string;
        readonly header: string;
        readonly status: AgendaMemberNoteStatus;
      } | null | undefined;
    };
  } | null | undefined;
  readonly " $fragmentType": "MemberNote_Booking";
};
export type MemberNote_Booking$key = {
  readonly " $data"?: MemberNote_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberNote_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberNote_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AgendaMemberNote",
              "kind": "LinkedField",
              "name": "memberNote",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "header",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "body",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "bddcdc109510462c382224355c286706";

export default node;
